import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { useMediaBreakpoints, useVariable } from '../../hooks';
import { TABS_BUTTON_HORIZONTAL_PADDING } from '../constants';
import { useCallback } from 'react';
var SCROLL_MULTIPLIER = {
  xs: 3,
  md: 4
};
export var useTabsScroll = function useTabsScroll(refs, refsInner, refList, tabNames) {
  var scrollMultiplier = useMediaBreakpoints(SCROLL_MULTIPLIER);
  var horizontalPadding = useMediaBreakpoints(TABS_BUTTON_HORIZONTAL_PADDING); // scroll into a selected tab

  var scrollToTab = useVariable(useCallback(function (nameTarget, smooth) {
    if (smooth === void 0) {
      smooth = true;
    }

    if (!nameTarget) {
      return;
    }

    var _tabNames$current$red = tabNames.current.reduce(function (acc, name) {
      var width = refs.current[name].clientWidth;
      acc.scrollWidth += width;

      if (!acc.current) {
        if (name === nameTarget) {
          acc.width = width;
          acc.current = true;
        } else {
          acc.left += width;
        }
      }

      return acc;
    }, {
      scrollWidth: 0,
      left: 0,
      width: 0,
      current: false
    }),
        left = _tabNames$current$red.left,
        width = _tabNames$current$red.width,
        parentScrollWidth = _tabNames$current$red.scrollWidth;

    var parentScrollLeft = refList.current.container.current.scrollLeft;
    var parentWidth = refList.current.container.current.clientWidth;
    var maxScroll = parentScrollWidth - parentWidth;

    if (left < parentScrollLeft + horizontalPadding * scrollMultiplier) {
      // moving back
      if (left + width < parentScrollLeft + parentWidth) {
        refList.current.container.current.scrollTo(_objectSpread({
          top: 0,
          left: Math.max(left - horizontalPadding * scrollMultiplier, 0, left - (parentWidth - width))
        }, smooth ? {
          behavior: 'smooth'
        } : {}));
      }
    } else if (left + width > parentScrollLeft + parentWidth - horizontalPadding * scrollMultiplier) {
      // moving forward
      if (left > parentScrollLeft) {
        refList.current.container.current.scrollTo(_objectSpread({
          top: 0,
          left: Math.min(left - (parentWidth - width) + horizontalPadding * scrollMultiplier, maxScroll, left)
        }, smooth ? {
          behavior: 'smooth'
        } : {}));
      }
    }
  }, [scrollMultiplier, horizontalPadding]));
  return scrollToTab;
};